"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var modalSlice_1 = require("@store/slices/modalSlice");
var react_redux_1 = require("react-redux");
var InfoModal_1 = __importDefault(require("./InfoModal"));
var RedirectModal_1 = __importDefault(require("./RedirectModal"));
var withModalWindow_1 = __importDefault(require("@components/_hoc/withModalWindow"));
function ModalManager() {
    var activeModal = (0, react_redux_1.useSelector)(function (state) { return state.modalSlice; }).activeModal;
    if (activeModal === modalSlice_1.ActiveModal.None)
        return;
    switch (activeModal) {
        case modalSlice_1.ActiveModal.Info:
            return (0, jsx_runtime_1.jsx)(InfoModal_1.default, {});
        case modalSlice_1.ActiveModal.Redirect:
            return (0, jsx_runtime_1.jsx)(RedirectModal_1.default, {});
        // case ActiveModal.Confirmation:
        //   return <ConfirmationModal></ConfirmationModal>;
    }
}
exports.default = (0, withModalWindow_1.default)(ModalManager);
